import React from 'react';
import './Presentation.css';
import QuotePreview from './QuotePreview';

/**
 * Presentation component for displaying the full slide deck
 * 
 * The slides are stored in the public/images/slides/ directory
 * For production use, ensure all slide images are copied to this directory
 */
const Presentation = ({ quoteDetails, projectName, quoteStyle }) => {
  // Define the slide data with actual path references
  const slides = [
    { id: 1, title: "Title Slide", src: "/images/slides/slide1.png" },
    { id: 2, title: "Density + BHN", src: "/images/slides/slide2.png" },
    { id: 3, title: "Coppell Pilot", src: "/images/slides/slide3.png" },
    { id: 4, title: "Privacy & Security", src: "/images/slides/slide4.png" },
    { id: 5, title: "Sensor Installation", src: "/images/slides/slide5.png" },
    { id: 6, title: "Technology Comparison", src: "/images/slides/slide6.png" },
    { id: 7, title: "Software API", src: "/images/slides/slide7.png" },
    // Slide 8 - Quote Preview (rendered as component)
    // Slide 9 - Floorplan (rendered from image)
  ];

  return (
    <div className="presentation-container">
      {/* Slides 1-7: Static presentation images */}
      {slides.map((slide) => (
        <div key={`slide-${slide.id}`} className="presentation-slide">
          {/* If the image exists, display it, otherwise show a placeholder */}
          <div className="presentation-slide-content">
            <img 
              src={slide.src} 
              alt={slide.title}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
                e.target.parentNode.classList.add('placeholder-slide');
                
                // Create placeholder content if image fails to load
                const placeholderDiv = document.createElement('div');
                placeholderDiv.className = 'placeholder-content';
                placeholderDiv.innerHTML = `
                  <h3>Slide ${slide.id}</h3>
                  <p>${slide.title}</p>
                  <p class="placeholder-note">Please add the image file to public/images/slides/slide${slide.id}.png</p>
                `;
                e.target.parentNode.appendChild(placeholderDiv);
              }}
            />
          </div>
        </div>
      ))}
      
      {/* Slide 8: Quote Preview (reuse the QuotePreview component) */}
      <div className="presentation-slide quote-slide">
        <QuotePreview
          quoteDetails={quoteDetails}
          projectName={projectName}
          style={quoteStyle}
        />
      </div>
      
      {/* Slide 9: Floorplan with visible elements */}
      <div className="presentation-slide">
        <div className="presentation-slide-content">
          <img 
            src="/images/slides/slide9.png" 
            alt="Floorplan with sensors"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              e.target.parentNode.classList.add('placeholder-slide');
              
              // Create placeholder content if image fails to load
              const placeholderDiv = document.createElement('div');
              placeholderDiv.className = 'placeholder-content';
              placeholderDiv.innerHTML = `
                <h3>Slide 9</h3>
                <p>Floorplan with Visible Elements</p>
                <p class="placeholder-note">Please add the floorplan image to public/images/slides/slide9.png</p>
              `;
              e.target.parentNode.appendChild(placeholderDiv);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Presentation; 